import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { CardVisual } from "./CardVisual";
import { ReceiptPicker } from "./ReceiptPicker";

const QUICK = [15, 25, 50, 100, 250];

export const DepositForm = ({ info, onDone, pending }) => {
  const [f, setF] = useState({ amount: "15" });
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (Number(f.amount) < info.min_deposit) return toast.error(`Minimum depozit ${info.min_deposit} AZN-dir`);
    setLoading(true);
    try {
      if (!file) { setLoading(false); return toast.error("Ödəniş çekinin (qəbzin) şəklini yükləyin"); }
      const fd = new FormData();
      fd.append("amount", String(Number(f.amount)));
      fd.append("receipt", file);
      await api.post("/wallet/deposit", fd);
      setFile(null);
      toast.success("Depozit sorğusu göndərildi. Təsdiqdən sonra balansa əlavə olunacaq.");
      setF({ amount: "15" });
      onDone();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid lg:grid-cols-2 gap-10" data-testid="deposit-section">
      <div className="space-y-6">
        <CardVisual number={info.deposit_card} />
        <ol className="space-y-3 text-sm text-zinc-400 list-decimal list-inside">
          <li>Yuxarıdakı karta istədiyiniz məbləği köçürün (min. {info.min_deposit} ₼).</li>
          <li>Ödənişin qəbzini (çekin şəklini) yükləyin və təsdiqləyin.</li>
          <li>Sorğu təsdiqləndikdən sonra məbləğ balansınıza əlavə olunur.</li>
        </ol>
      </div>
      {pending ? (
        <div className="rounded-3xl border border-amber-400/40 bg-amber-400/5 p-8 space-y-3 h-fit" data-testid="deposit-pending-notice">
          <h3 className="font-display font-bold text-xl text-amber-300">Depozitiniz yoxlanılır</h3>
          <p className="text-zinc-300">{pending.amount.toFixed(2)} ₼ məbləğində sorğunuz təsdiq gözləyir.</p>
          <p className="text-sm text-zinc-500">Təsdiq və ya ləğv olunana qədər yeni depozit sorğusu göndərmək mümkün deyil.</p>
        </div>
      ) : (
      <form noValidate onSubmit={submit} className="rounded-3xl border border-white/10 bg-[#111] p-8 space-y-5" data-testid="deposit-form">
        <div className="space-y-2">
          <span className="text-xs uppercase tracking-[0.2em] text-zinc-500">Məbləğ (AZN)</span>
          <input className="jp-input font-display text-xl" type="number" min={info.min_deposit} step="0.01" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} data-testid="deposit-amount-input" />
          <div className="flex flex-wrap gap-2 pt-1">
            {QUICK.map((q) => (
              <button type="button" key={q} onClick={() => setF({ ...f, amount: String(q) })} className={`btn-ghost rounded-full px-4 py-1.5 text-sm ${Number(f.amount) === q ? "border-[#D4AF37] text-[#FFD700]" : ""}`} data-testid={`deposit-quick-${q}`}>{q} ₼</button>
            ))}
          </div>
        </div>
        <ReceiptPicker file={file} onChange={setFile} />
        <button disabled={loading} className="btn-gold w-full rounded-full py-4 font-display font-bold" data-testid="deposit-submit-btn">{loading ? "Göndərilir..." : "Depoziti təsdiqlə"}</button>
      </form>
      )}
    </div>
  );
};
